import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules'

/**
 * If the current request was opened as part of the vresdiatrofologo SSO
 * reverse flow (`?sso_return=1`), mint a bridge token and hand the user off
 * to vres. Returns `true` when the redirect is in flight (caller should bail
 * out of any further navigation), `false` when there's nothing to do or the
 * bridge request failed.
 *
 * Takes a `{ query, axios }` context rather than a Vue vm so it can be called
 * from the router guard (no vm available there) as well as from
 * performAuthSuccessActions (post-login).
 */
export async function tryPerformSsoRedirect({ query, axios }) {
  if (!query.sso_return) return false;
  try {
    const body = typeof query.next === 'string' && query.next ? { next: query.next } : {};
    const res = await axios.post('/sso/issue', body);
    window.location.assign(res.data.url);
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Post-auth-success redirect flow shared by login + register.
 * `logoutFallbackRoute` is the route to send the user to when they arrived
 * via a logout redirect (login → 'home', register → 'confirm-account').
 *
 * Lives outside `@state/helpers` because that file is loaded at app bootstrap
 * (via `top-bar.vue`) and pulling `dispatch-action-for-all-modules` in there
 * creates a circular-init race with `@state/store`.
 */
export async function performAuthSuccessActions(vm, data, logoutFallbackRoute) {
  const isStudent = data.user?.tier === 'student';

  vm.$store.dispatch('auth/cacheUser', data);

  // Students have free access — never route them to purchase.
  if (!isStudent && !vm.isOfflineVersion && !data.user.isPremium) {
    return vm.$router.push({name: 'purchase-athlisis'});
  }
  dispatchActionForAllModules('init');

  if (await tryPerformSsoRedirect({ query: vm.$route.query, axios: vm.$axios })) return;

  const redirectFrom = vm.$route.query.redirectFrom;
  if (redirectFrom && redirectFrom.includes('logout')) {
    vm.$router.push({name: logoutFallbackRoute});
  }
  vm.$router.push(redirectFrom || {name: 'home'});
}
